<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'ApPayments_Title' | translateWF: 'AP Payments' }}</h1>
          <p class="page__subtitle">
            {{
              'ApPayments_Subtitle'
                | translateWF
                  : 'Settle posted invoices from a bank
            account.'
            }}
          </p>
        </div>
        <div class="page__title_buttons">
          <p-speedDial [model]="speedDialItems" direction="left" [transitionDelay]="80">
            <ng-template #button let-toggleCallback="toggleCallback">
              <p-button (click)="toggleCallback($event)" [label]="'ApPayments_New' | translateWF: 'New payment'" icon="pi pi-plus" />
            </ng-template>
            <ng-template #item let-item let-toggleCallback="toggleCallback">
              <p-button variant="outlined" severity="secondary" (click)="toggleCallback($event, item)" [label]="item.label" [icon]="item.icon" />
            </ng-template>
          </p-speedDial>
          <p-button [label]="'Export' | translateWF: 'Export'" icon="pi pi-download" variant="outlined" severity="secondary" [disabled]="true" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'ApPayments_Title' | translateWF: 'AP Payments'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="payments()" selectionMode="single" [lazy]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" (onSort)="onSort($event)">
            <ng-template pTemplate="header">
              <tr>
                <!-- Sorting is server-side (the table holds one page). Provider sorts through a join on the
                   Business master — the payment stores only a reference — which is why it is the one column
                   here whose order costs a lookup. Invoices / Bank account stay unsortable: both are lists
                   or joined labels with no single field to order rows by. -->
                <th>{{ 'ApPayment_Number' | translateWF: 'Payment #' }}</th>
                <th pSortableColumn="providerName">{{ 'ApPayment_Provider' | translateWF: 'Provider' }}<p-sortIcon field="providerName" /></th>
                <th>{{ 'ApPayment_Invoices' | translateWF: 'Invoices' }}</th>
                <th pSortableColumn="paymentDate">{{ 'ApPayment_Date' | translateWF: 'Payment date' }}<p-sortIcon field="paymentDate" /></th>
                <th>{{ 'ApPayment_BankAccount' | translateWF: 'Bank account' }}</th>
                <th class="text-right" pSortableColumn="amount">{{ 'ApPayment_Amount' | translateWF: 'Amount' }}<p-sortIcon field="amount" /></th>
                <th>{{ 'Status' | translateWF: 'Status' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let payment = getRowData(rowData);
              <tr>
                <td>
                  <a class="cs-table-link" (click)="redirectToDetails(payment.id ?? undefined)">{{ payment.number }}</a>
                </td>
                <td>{{ payment.providerName || payment.providerCode }}</td>
                <!-- A payment can settle twenty invoices, so the column names the first and counts the rest —
                   the whole list rides along in the tooltip rather than stretching every row to fit. -->
                <td>
                  @let invoices = invoiceNumbers(payment);
                  @if (invoices.length === 0) {
                    <span class="text-surface-500">—</span>
                  } @else {
                    <span [pTooltip]="invoices.join(', ')" tooltipPosition="top">{{ invoices[0] }}</span>
                    @if (invoices.length > 1) {
                      <span class="text-surface-500 ml-1">+{{ invoices.length - 1 }}</span>
                    }
                  }
                </td>
                <td>{{ payment.paymentDate | date: 'dd/MM/yyyy' }}</td>
                <td>{{ bankLabel(payment.bankAccountReference) }}</td>
                <td class="text-right">{{ payment.amount | number: '1.2-2' }} {{ currencyLabel(payment.currency) }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(payment.status)" [value]="statusLabel(payment.status)" />
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">{{ 'ApPayments_NotFound' | translateWF: 'No payments found' }}</td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
